<div class="flex shadow-sm rounded-md">
  <div
    class="flex-shrink-0 flex items-center justify-center w-16 text-white text-sm leading-5 font-medium rounded-l-md"
    [class.bg-pink-600]="!orgaUser.data.onboardingCompleted"
    [class.bg-green-600]="orgaUser.data.onboardingCompleted"
  >
    @if (orgaUser.data.onboardingCompleted) {
      <div>{{ orgaUser.data.userInitials }}</div>
    }
    @if (!orgaUser.data.onboardingCompleted) {
      <div>?</div>
    }
  </div>
  <div
    class="flex-1 flex items-center justify-between border-t border-r border-b border-edge bg-surface rounded-r-md truncate"
  >
    <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
      <div
        class="text-fg-primary font-medium hover:text-fg-muted transition ease-in-out duration-150"
      >
        @if (orgaUser.data.onboardingCompleted) {
          <div>{{ orgaUser.data.userDisplayName }}</div>
        }
        @if (!orgaUser.data.onboardingCompleted) {
          <div>Onboarding läuft...</div>
        }
      </div>
      <p class="text-fg-secondary">{{ orgaUser.data.email }}</p>
      <p class="text-fg-secondary">Level: {{ orgaUser.data.role }}</p>
    </div>
    @if (orgaUser.data.role !== 'owner' && role === 'owner') {
      <div class="flex-shrink-0 pr-2">
        <app-dropdown-minimal-menu>
          <app-dropdown-button>
            <app-ng-icon
              name="heroEllipsisVerticalSolid"
              class="text-3xl"
              strokeWidth="3"
            ></app-ng-icon>
          </app-dropdown-button>
          <app-dropdown-item (menuClick)="deleteOrgaUser()">Mitarbeiter löschen </app-dropdown-item>
        </app-dropdown-minimal-menu>
      </div>
    }
  </div>
</div>
